/* global CVP */

// ### AdobeFlashAuth
//
// Using Adobe's AccessEnabler SWF.

'use strict';

var AdobeBaseAuth = require('./adobebaseauth');
var App = require('./app');
var ENV = require('./env');
var _ = require('./vendor/underscore');
var _logger = require('./logger');
var Dom = require('./dom');


var AdobeFlashAuth = AdobeBaseAuth.extend({
	type: 'flash',
	PRODUCTION_ACCESS_ENABLER_URL: window.location.protocol + '//' + App.ADOBE_ENTITLEMENT_PRODUCTION_HOST + '/entitlement/AccessEnabler.swf',
	STAGING_ACCESS_ENABLER_URL: window.location.protocol + '//' + App.ADOBE_ENTITLEMENT_STAGING_HOST + '/entitlement/AccessEnabler.swf',
	PLATFORM_PROPERTY: 'flash',

	getSelectedProvider: function (callback, context) {
		_logger.log('AdobeFlashAuth:getSelectedProvider');

		if (!_.isFunction(callback)) {
			_logger.error('getSelectedProvider requires an async callback');
			throw new Error('AdobeFlashAuth::getSelectedProvider requires an async callback');
		}

		this.once('selectedProvider', callback, context);

		_logger.info('Adobe:call - getSelectedProvider');
		var result = this.accessEnabler.getSelectedProvider();
		_logger.info('Adobe:result - getSelectedProvider', result);

		result = this._validateSelectedProvider(result);

		// immediately resolve as the Flash AccessEnabler is synchronous
		this.emit('selectedProvider', result);
	},

	setProviderDialogURL: function (url) {
		_logger.log('AdobeFlashAuth:setProviderDialogURL', arguments);

		this.accessEnabler.setProviderDialogURL(url);
	},

	externalizeCallbacks: function () {
		_logger.log('AdobeFlashAuth:externalizeCallbacks');

		// this takes all the internal methods for adobe callbacks and
		// exposes them to the global scope so adobe can access them
		this._super();

		window.swfLoaded = _.bind(this._adobeCallback_swfLoaded, this);
	},

	_adobeCallback_swfLoaded: function () {
		_logger.info('Adobe:callback - swfLoaded');

		// set a pointer to Adobe's AccessEnabler swf object
		this.accessEnabler = Dom.id(this.accessEnablerId);

		this._adobeLoaded();
	},

	init: function (options) {
		_logger.log('AdobeFlashAuth:init', arguments);

		this._super(options);

		this.configuredEnv = options.vendorEnv;

		this.accessEnablerId = options.id || 'AccessEnabler';
		this.accessEnablerUrl = (
			this.getUrlForEnv(ENV.getVendorOverrideParam(), options.adobeSwfUrl)
			|| options.adobeSwfUrl
			|| this.getUrlForEnv(options.vendorEnv)
			|| this.PRODUCTION_ACCESS_ENABLER_URL
		);
	},

	install: function () {
		_logger.log('AdobeFlashAuth:install');

		this._super();

		// create the div that the swf should be loaded into
		var swfContainer = Dom.id(this.accessEnablerId);
		if (!swfContainer) {
			swfContainer = Dom.create('div');
			Dom.attr(swfContainer, 'id', this.accessEnablerId);
			Dom.append(swfContainer);
		}

		var importantSuffix = ' !important';
		var style = [
			'position: fixed' + importantSuffix,
			'top: 0' + importantSuffix,
			'left: 99px' + importantSuffix,
			'z-index: 9999' + importantSuffix,
			'visibility: visible' + importantSuffix,
			'display: inline-block'
		].join('; ');

		CVP.swfobject.embedSWF(
			this.accessEnablerUrl, this.accessEnablerId,
			1, 1,
			App.REQUIRED_FLASH_VERSION,
			null,  // express install
			null,  // flashvars
			{  // params
				menu: 'false',
				quality: 'high',
				wmode: 'transparent',
				align: 'middle',
				swliveconnect: 'true',
				AllowScriptAccess: 'always'
			},
			{  // attributes
				id: this.accessEnablerId,
				name: this.accessEnablerId,
				style: style
			}
		);
	}

});


module.exports = AdobeFlashAuth;
